import React from 'react'
// import { TypeInfo } from './../../node_modules/ts-node/dist/index.d';
import gps from '../assets/gps.svg'
import weight from '../assets/weight.svg'
import quantity from '../assets/quantity.svg'
import box from '../assets/box.svg'
import height from '../assets/height.svg'
import length from '../assets/length.svg'
import width from '../assets/width.svg'
import arrow from '../assets/arrow.svg'
import DHL from '../assets/CourierLogos/DHL.png'
// import { useLocation } from 'react-router-dom';


function DashBookingData({ bookingDetails, onReconcileInsurance, isReconcilingInsurance, insuranceReconcileMessage }) {
    
    const booking = bookingDetails;
    const insurance = booking?.Insurance || booking?.insurance;
    const insuranceStatus = insurance?.status || insurance?.Status || booking?.insuranceStatus || booking?.Insurance_Status || '';
    const normalizedInsuranceStatus = String(insuranceStatus).toLowerCase();
    const canReconcileInsurance = normalizedInsuranceStatus.includes('pending') || normalizedInsuranceStatus.includes('fail');
    const formatInsuranceAmount = (value) => {
        if (value === null || value === undefined || value === '') return '—';
        const amount = Number(value);
        return Number.isFinite(amount)
            ? new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(amount)
            : '—';
    };

    if (!bookingDetails) {
        return <div></div>;
    }

    return (
        <div className='container module-close'>
            <div className="row">
                <div className="col-lg-12">
                    {/* <h2>Your Bookings</h2> */}
                    <div className="booked-booking px-4 py-4 mb-3 position-relative">
                        <div>
                            <div className="bkng-main-info d-flex align-items-center justify-content-between flex-wrap">
                                <span className='t-id'>Tracking ID: #{booking.OwcNumber}</span>
                                <span className='bkng-status'>{booking.Booking_Status}</span>
                                <span className='bkng-courier center-center'>Courier: {booking.Selected_Courier}</span>
                                <span className='bkng-EDD'>EDD: {booking.EDD}</span>
                                <span className='bkng-Price'>Paid: ${booking.Courier_Price} AUD</span>
                            </div>
                        </div>
                        <div className='row mt-4'>
                            <div className="col-lg-8">
                                <div className="bkng-info d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <img src={weight} alt="" />
                                        <span className='mb-0'>{booking.P_Weight} KG</span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <img style={{ width: '2rem' }} src={quantity} alt="" />
                                        <span className='mb-0'>{booking.P_Quantity} item</span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <img style={{ width: '1.5rem' }} src={box} alt="" />
                                        <span className='mb-0'>{booking.P_Type}</span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <img src={height} alt="" />
                                        <span className='mb-0'>{booking.D_Height} cm</span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <img src={length} alt="" />
                                        <span className='mb-0'>{booking.D_Length} cm</span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <img src={width} alt="" />
                                        <span className='mb-0'>{booking.D_Width} cm</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {insurance && (
                            <section
                                aria-labelledby="admin-booking-insurance-title"
                                style={{ marginTop: '1.25rem', padding: '1rem', border: '1px solid #e5e7eb', borderRadius: '0.5rem' }}
                            >
                                <h3 id="admin-booking-insurance-title" style={{ margin: '0 0 0.75rem', fontSize: '1rem' }}>Shipment insurance</h3>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
                                    <div><span>Status </span><strong>{insuranceStatus || 'Not available'}</strong></div>
                                    <div><span>Coverage </span><strong>{formatInsuranceAmount(insurance.coverage ?? insurance.Coverage)}</strong></div>
                                    <div><span>Premium </span><strong>{formatInsuranceAmount(insurance.premium ?? insurance.Premium)}</strong></div>
                                    {(insurance.category || insurance.Category) && <div><span>Category </span><strong>{insurance.category || insurance.Category}</strong></div>}
                                    {(insurance.condition || insurance.Condition) && <div><span>Condition </span><strong>{insurance.condition || insurance.Condition}</strong></div>}
                                </div>
                                {(insurance.message || insurance.Message) && (
                                    <p style={{ margin: '0.75rem 0 0' }}>{insurance.message || insurance.Message}</p>
                                )}
                                {canReconcileInsurance && (
                                    <div style={{ marginTop: '0.75rem' }}>
                                        <p role="status" style={{ margin: '0 0 0.75rem' }}>
                                            Insurance is not confirmed. Please contact support for assistance.
                                        </p>
                                        <button
                                            type="button"
                                            className="btn btn-smth"
                                            onClick={() => onReconcileInsurance?.(booking)}
                                            disabled={isReconcilingInsurance}
                                            aria-busy={isReconcilingInsurance}
                                        >
                                            {isReconcilingInsurance ? 'Checking insurance status…' : 'Check insurance status'}
                                        </button>
                                    </div>
                                )}
                                {insuranceReconcileMessage && (
                                    <p
                                        role={insuranceReconcileMessage.startsWith('Unable to check') ? 'alert' : 'status'}
                                        aria-live="polite"
                                        style={{ margin: '0.75rem 0 0' }}
                                    >
                                        {insuranceReconcileMessage}
                                    </p>
                                )}
                            </section>
                        )}
                        <div className="admin-handling-summary">
                            <div className={booking.isDangerous ? 'is-alert' : ''}>
                                <span>Dangerous goods</span>
                                <strong>{booking.DangerousGoods || (booking.isDangerous ? 'Other' : 'None')}</strong>
                            </div>
                            <div className={booking.SpecialHandling && booking.SpecialHandling !== 'None' ? 'is-alert' : ''}>
                                <span>Special handling</span>
                                <strong>{booking.SpecialHandling || 'None'}</strong>
                            </div>
                            <div>
                                <span>Stackability</span>
                                <strong>{booking.Stackability === true || booking.Stackability === 'true' ? 'Stackable' : 'Non-stackable'}</strong>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-lg-6">
                                <div className="row">
                                    <div>
                                        <p className='mb-0'>
                                            <img style={{ width: '1rem', marginRight: '0.3rem' }} src={gps} alt="" />
                                            <span className='fw-600 fs-5'>From </span>
                                            <span style={{ marginLeft: '0.5rem' }} className='fw-500'>
                                                <small>{booking.From_Country}, {booking.From_City} {booking.From_P_Code}</small>
                                            </span>
                                        </p>
                                    </div>
                                    <div>
                                        <p><span className='fw-600'>Sender: </span>{booking.Sender_Fname} {booking.Sender_Lname}</p>
                                        <p><span className='fw-600'>Email: </span>{booking.Sender_Email}</p>
                                        <p><span className='fw-600'>Phone: </span>{booking.Sender_Phone}</p>
                                        <p><span className='fw-600'>Address: </span>{booking.From_addr1}</p>
                                        {booking.From_addr2 && <p><span className='fw-600'>Address 2: </span>{booking.From_addr2}</p>}
                                        {booking.From_PIns && <p><span className='fw-600'>Pickup Instructions: </span>{booking.From_PIns}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="row">
                                    <div>
                                        <p className='mb-0'>
                                            <img style={{ width: '1rem', marginRight: '0.3rem' }} src={gps} alt="" />
                                            <span className='fw-600 fs-5'>To </span>
                                            <span style={{ marginLeft: '0.5rem' }} className='fw-500'>
                                                <small>{booking.To_Country}, {booking.To_City} {booking.To_P_Code}</small>
                                            </span>
                                        </p>
                                    </div>
                                    <div>
                                        <p><span className='fw-600'>Recipient: </span>{booking.Rec_Fname} {booking.Rec_Lname}</p>
                                        <p><span className='fw-600'>Email: </span>{booking.Rec_Email}</p>
                                        <p><span className='fw-600'>Phone: </span>{booking.Rec_Phone}</p>
                                        <p><span className='fw-600'>Address: </span>{booking.To_addr1}</p>
                                        {booking.To_addr2 && <p><span className='fw-600'>Address 2: </span>{booking.To_addr2}</p>}
                                        {booking.To_DIns && <p><span className='fw-600'>Delivery Instructions: </span>{booking.To_DIns}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button className="btn btn-close" />
                    </div>

                </div>
                <div className="col-lg-3">

                </div>
            </div>
        </div>
    )
}

export default DashBookingData
